import styled from "styled-components";

const HistoricalItemsStyled = styled.div`
    width: 100%;

.pageTitle {
    font-size: 2.6rem;
    font-weight: 700;
    margin-bottom: 20px;
    color: #1B1E1C;
}


.backButton {
   display: flex;
   gap: 8px;
   align-items: center;
   justify-content: start;
   color: #008755;
   cursor: pointer;
   font-size: 1.6rem;
   font-weight: 700;
   margin-bottom: 20px;
}

.arrow {
    rotate: 180deg;
 }
`;

export { 
	HistoricalItemsStyled
 };
